<!--TeTask:待办任务 2021/03/17 11:08:09 YuAng-->

<template>
  <div class="its-te-task">
    <p class="its-task-header">
      <span class="its-icon its-icon-naozhongshizhongshijian_jurassic"></span>
      <span style="margin-left: 4px">待办任务</span>
      <el-tooltip placement="right-start">
        <div slot="content" style="line-height: 1.5">待办任务：<br />展示未发布任务、未截止任务、已截止任务（0 &lt; 当前日期-截止日期 &lt;= 2）哦~</div>
        <span class="its-icon its-icon-question-circle"></span>
      </el-tooltip>
    </p>
    <ul v-if="tasks && tasks.length > 0" class="its-task-list">
      <li v-for="(item, index) in tasks" :key="'task-' + index">
        <div class="its-item-left">
          <p class="its-task-title">
            <span class="its-task-type" :class="item.missionType">{{item.missionType | taskTypeName}}</span>
            <span class="its-task-name" data-io-click="tracker" @click="jumpNext(index)">{{item.courseName ? `【${item.courseName}】` : '' }}{{item.businessName}}</span>
            <span class="its-task-status" :class="item.status">({{item.status | statusName}})</span>
          </p>
          <p class="its-task-mark">
            <!-- 创建时间 -->
            <span v-if="item.status === 'UNPUBLISHED'">创建时间: {{item.created | formatDate('yyyy-M-d hh:mm week')}}</span>
            <template v-else>
              <!-- 已提交班级 -->
              <span v-if="item.classId">已提交：{{item.className}}<i class="its-i-blue">{{item.submittedCount}}</i>/{{item.studentCount}}</span>
              <span v-else>未提交</span>
              <!-- 截止时间 -->
              <span>截止时间：{{item.expiredDate | formatDate('yyyy-M-d hh:mm week')}}</span>
            </template>
          </p>
        </div>
        <div class="its-item-right">
          <!-- 只有截止的训练才展示正确率 -->
          <p class="its-item-rate" :style="{visibility: item.avgClassCorrectRate >=0 && item.status === 'CLOSED' ? '' : 'hidden'}">
            <span class="value">{{item.avgClassCorrectRate * 100 | removePointZero}}%</span>
            <span>正确率</span>
          </p>
          <!-- 预习的操作：编辑、查看 -->
          <p v-if="item.missionType.indexOf('TUTORIAL') !== -1" class="its-item-action" :class="item.status" style="width: 50%;margin-left:calc(50% - 50px)">
            <a v-if="item.status === 'UNPUBLISHED' || item.status === 'PUBLISH_FAILED'" class="preview link" :href="`/preclass/#/stage/${item.stageId}/subject/${item.courseId}/task/${item.applyId}?from=teacher_home`" target="_self">
              编辑
            </a>
            <a v-else class="preview link" :href="`/preclass/#/detail/${item.applyId}?classId=${item.classId}&status=${item.status}&from=teacher_home`" target="_self">
              查看
            </a>
          </p>
          <!-- 训练的操作：批改、查看 -->
          <p v-else-if="item.missionType.indexOf('TRAINING') !== -1" class="its-item-action" :class="item.status" style="width: 50%;margin-left:calc(50% - 50px)">
            <a v-if="item.status === 'UNPUBLISHED' || item.status === 'PUBLISH_FAILED'" class="preview link" :href="`/training/#/create?start=draft&draftId=${item.applyId}&from=teacher_home`" target="_self">
              编辑
            </a>
            <a v-else class="preview link" :href="`/training/#/detail/${item.applyId}?classId=${item.classId}&from=teacher_home`" target="_self">
              查看
            </a>
            <!-- 放开时，将top的14改为4 -->
            <span v-if="false" class="correct link">批改</span>
          </p>
          <!-- 任务的操作：更多 - 忽略，暂时隐藏 -->
          <p v-if="false" style="width: 10%" :data-index="index">
            <popover-select custom jump :group="more" :fatherAction="selectAction">
              <span class="its-icon its-icon-gengduo"></span>
            </popover-select>
          </p>
        </div>
      </li>
    </ul>
    <div-no-data v-else style="height: calc(100% - 100px)">
      <p v-if="promise" class="empty">
        数据加载中...
      </p>
      <p v-else class="empty">
        还没有待办任务哦~，快去
        <a style="color:#2695ff" :href="link.preclass" target="_self">布置预习</a> 或
        <a style="color:#2695ff" :href="link.training" target="_self">布置训练</a>
        吧~
      </p>
    </div-no-data>
  </div>
</template>
<script>
import { teacherHomeApi } from '@/utils/api'
import PopoverSelect from '../../../../components/PopoverSelect.vue'
import DivNoData from '../../../components/DivNoData.vue'
export default {
  name: 'TeTask',
  components: { PopoverSelect, DivNoData },
  props: {
    link: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      tasks: [],
      more: {
        type: 'more', title: '更多', items: [{ id: 0, name: '忽略' }]
      },
      promise: null
    }
  },
  created() {
    this.promise = teacherHomeApi.getTasks().then((resp) => {
      this.tasks = resp.body
    })
    setTimeout(() => {
      this.promise = null
    }, 2 * 1000);
  },
  methods: {
    selectAction: function (action) {
      const index = action.$el.parentNode.getAttribute("data-index")
      const task = this.tasks[parseInt(index)]
      alert(task.businessName)
    },
    jumpNext: function (index) {
      // 标题的点击跳转url和右侧的preview的超链接一致，可以不用考虑任务的状态，也能跳转正确
      const li = this.$el.querySelectorAll('.its-task-list li')[index]
      const link = li.querySelector('.preview')
      window.open(link.href, link.target)
    }
  },
  filters: {
    taskTypeName: function (type) {
      const names = {
        'TUTORIAL': '预习', // 导学
        'TUTORIAL_CLASS': '预习',  // 导学班级
        'HOMEWORK': '训练',
        'INVESTIGATE': '调研',
        'COMMENT': '评论',
        'TRAINING': '训练',
        'TRAINING_ARCHETYPE': '训练'
      }
      return names[type]
    },
    statusName: function (status) {
      const names = {
        'UN_START': '未开始',
        'UNPUBLISHED': '未发布',
        'PUBLISHED': '进行中',
        'PROCESSING': '进行中',
        'PUBLISHING': '发布中',
        'PUBLISH_FAILED': '发布失败',
        'CHARGED': '已截止',
        'CLOSED': '已截止',
      }
      return names[status]
    }
  }
}
</script>

<style scoped>
.its-te-task {
  height: calc(100% - 333px);
  background: white;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  border-radius: 4px;
  margin: 20px 0;
}

.its-task-header {
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  border-bottom: 1px solid #e5e5e5;
  margin: 0 12px;
}

.its-task-header span {
  display: inline-block;
  vertical-align: middle;
}

.its-icon-naozhongshizhongshijian_jurassic {
  color: #2695ff;
}

.its-task-list {
  height: calc(100% - 60px);
  overflow: auto;
  padding-bottom: 120px;
  margin: 0 8px;
  padding: 0 4px 0 12px;
}

.its-task-list li {
  width: 100%;
  height: 64px;
  padding: 13px 0 33px 0;
}
.its-item-right,
.its-item-left {
  float: left;
  height: 100%;
}
.its-item-left {
  width: calc(100% - 100px);
  font-size: 12px;
  color: #757575;
}

.its-item-right {
  width: 100px;
}

.its-item-right p {
  float: left;
  text-align: center;
}

.its-item-right p span {
  width: 100%;
  display: inline-block;
}

.its-task-mark {
  font-size: 12px;
  color: #999999;
  margin-top: 8px;
}

.its-task-mark span {
  margin-right: 32px;
  width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

.its-i-blue {
  font-style: normal;
  color: #2695ff;
  margin-left: 4px;
}

.its-task-title {
  height: 20px;
  line-height: 20px;
  cursor: pointer;
}

.its-task-title span {
  display: inline-block;
  vertical-align: middle;
}

.its-task-title .its-task-type {
  border-radius: 2px;
  padding: 0 4px;
  height: 16px;
  line-height: 16px;
  color: #22A1FF;
  background: #E8F5FE;
}

.its-task-title .its-task-name {
  font-size: 14px;
  color: #333333;
  margin: 0 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 100px);
}

.its-task-name:hover {
  color: #2695ff;
}

.its-task-status.PROCESSING,
.its-task-status.PUBLISHING {
  color: #0080ff;
}

.its-task-status.UNPUBLISHED {
  color: #FF9551;
}
.its-task-status.PUBLISH_FAILED,
.its-item-action .correct {
  color: #ff4725;
}

.its-item-rate {
  background: url("../../../../assets/images/task-rate-bg.png") no-repeat;
  width: 50px !important;
  height: 52px;
  font-size: 12px;
  color: #999999;
  background-size: 100%;
  padding: 5px 0 15px 0;
}

.its-item-rate .value {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
}

.its-item-action a {
  cursor: pointer;
  margin-top: 2px;
  display: none !important;
}

.its-item-action .preview {
  color: #2695ff;
  margin-top: 14px;
  display: inline-block !important;
}

.its-item-action.CLOSED .preview {
  margin-top: 14px;
}

.its-item-action.CLOSED .correct {
  display: inline-block !important;
}

.its-icon-gengduo {
  color: #999999;
  margin-top: 16px;
}

.its-item-right >>> .more {
  margin-left: 0;
}
</style>
